/**
 * Helper di stampa condivisi tra SchedaLavoroV2 e SchedaLavoroV3.
 *
 * Estratti da SchedaLavoroV2.tsx (righe 45-82) — corpo delle funzioni
 * INVARIATO. Nessuna logica nuova.
 */

import { API_URL } from '@/config/api'

// ── Stampa con foto: helper a livello di modulo ───────────────────────────────

/** Rimuove il prefisso /api/v1 dall'URL restituito dal backend prima di
 *  passarlo ad axiosInstance (che ha già baseURL=/api/v1). */
export function toAxiosPrintPath(url: string): string {
  if (API_URL && url.startsWith(API_URL)) return url.slice(API_URL.length)
  return url
}

/** Scarica un'immagine da un Blob, la ridimensiona su canvas (lato lungo max
 *  1400px, senza ingrandire), e restituisce un data-URL JPEG (qualità 0.82). */
export function resizeImageForPrint(blob: Blob, maxLongSide = 1400): Promise<string> {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(blob)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(objectUrl)
      const { naturalWidth: w, naturalHeight: h } = img
      // Non ingrandire se già più piccola del limite
      const scale = Math.min(1, maxLongSide / Math.max(w, h))
      const targetW = Math.round(w * scale)
      const targetH = Math.round(h * scale)
      const canvas = document.createElement('canvas')
      canvas.width = targetW
      canvas.height = targetH
      const ctx = canvas.getContext('2d')
      if (!ctx) { reject(new Error('Canvas context unavailable')); return }
      ctx.drawImage(img, 0, 0, targetW, targetH)
      resolve(canvas.toDataURL('image/jpeg', 0.82))
    }
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl)
      reject(new Error('Image load failed'))
    }
    img.src = objectUrl
  })
}

export type PrintOption = 'none' | 'accettazione' | 'all'
